import { Textarea } from "@/components/shadcn/textarea";
import { FieldPath, FieldValues } from "react-hook-form";
import { FormFieldBase, FormFieldCommonProps } from "./form-field-base";

type TextAreaFormFieldProps<
    TFieldValues extends FieldValues = FieldValues,
    TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = FormFieldCommonProps<TFieldValues, TName> & {
    placeholder?: string;
};

export function TextAreaFormField<
    TFieldValues extends FieldValues = FieldValues,
    TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({ placeholder, ...props }: TextAreaFormFieldProps<TFieldValues, TName>) {
    return (
        <FormFieldBase
            {...props}
            renderField={(field, fieldState, disabled) => (
                <Textarea
                    placeholder={placeholder}
                    className="min-h-[80px]"
                    aria-invalid={fieldState.invalid}
                    disabled={disabled}
                    {...field}
                />
            )}
        />
    );
}
